import { Link } from 'react-router-dom';
interface BreadcrumbProps {
  pageName: string;
}
const Breadcrumb = ({ pageName }: BreadcrumbProps) => {
  return (
    <div className="mb-6 flex flex-col rtl gap-3 sm:flex-row sm:items-center sm:justify-between" style={{fontFamily:"Btitr"}}>
      <h2 className="text-title-md2 font-semibold text-black dark:text-white" >
        {pageName}
      </h2>

      <nav>
        <ol className="flex items-center gap-2 font-bold" style={{fontFamily:"Btitr"}}>
          <li>
            <Link to="/">داشبورد /</Link>
          </li>
          <li className="text-primary">{pageName}</li>
        </ol>
      </nav>
    </div>
  );
};

export default Breadcrumb;
